export const IMPRESSION_THRESHOLD = 0.5;
export const ELEMENT_INTERSECTION_RATIO = 0.5;
